import publish from './publish';
import result from './result';
import optionsAnalysis from './optionsAnalysis';
import swotAnalysis from './swotAnalysis';
import targetAnalysis from './targetAnalysis';
import result2 from './result2';
import analysis from './analysis';

export default {
    publish,
    result,
    optionsAnalysis,
    swotAnalysis,
    targetAnalysis,
    result2,
    analysis
}